<template>
  <ExamStart :path="'/entrain'" style="margin-top: 0px;"></ExamStart>
</template>

<script>
  import ExamStart from '@/page/modules/questionnaire/result'
  export default {
    components: { ExamStart },
    mounted () {
    },
    data () {
      return {
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/page/entrain/questionnaire/result.vue